module.exports = __webpack_public_path__ + "img/联通.1e64a4fd.jpg";